import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_lancar_materia_prima_etapa_producao = _resolveComponent("lancar-materia-prima-etapa-producao")!
  const _component_a_tab_pane = _resolveComponent("a-tab-pane")!
  const _component_lancar_produto_acabado_etapa_producao = _resolveComponent("lancar-produto-acabado-etapa-producao")!
  const _component_engenharia_controle = _resolveComponent("engenharia-controle")!
  const _component_engenharia_cip = _resolveComponent("engenharia-cip")!
  const _component_a_tabs = _resolveComponent("a-tabs")!

  return (_openBlock(), _createBlock(_component_a_tabs, {
    activeKey: _ctx.state.indexSelecionado,
    "onUpdate:activeKey": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.state.indexSelecionado) = $event))
  }, {
    default: _withCtx(() => [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.computedEtapas, (etapa, index) => {
        return (_openBlock(), _createBlock(_component_a_tab_pane, {
          key: index,
          tab: etapa.descricao
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_tabs, null, {
              default: _withCtx(() => [
                (_openBlock(), _createBlock(_component_a_tab_pane, {
                  key: 0,
                  tab: 'Matéria-prima'
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_lancar_materia_prima_etapa_producao, {
                      materiaPrima: _ctx.computedEtapas[index].materiasPrimas,
                      "onUpdate:materiaPrima": ($event: any) => ((_ctx.computedEtapas[index].materiasPrimas) = $event),
                      codigoEtapa: _ctx.computedEtapas[index].codigoEtapaProducao,
                      empresas: _ctx.props.empresas,
                      visivel: true
                    }, null, 8, ["materiaPrima", "onUpdate:materiaPrima", "codigoEtapa", "empresas"])
                  ]),
                  _: 2
                }, 1024)),
                (_openBlock(), _createBlock(_component_a_tab_pane, {
                  key: 1,
                  tab: 'Produto Acabado'
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_lancar_produto_acabado_etapa_producao, {
                      produtoAcabado: _ctx.computedEtapas[index].produtosAcabados,
                      "onUpdate:produtoAcabado": ($event: any) => ((_ctx.computedEtapas[index].produtosAcabados) = $event),
                      codigoEtapa: _ctx.computedEtapas[index].codigoEtapaProducao,
                      empresas: _ctx.props.empresas,
                      "v-model:visivel": _ctx.state.exibirProdutoAcabado
                    }, null, 8, ["produtoAcabado", "onUpdate:produtoAcabado", "codigoEtapa", "empresas", "v-model:visivel"])
                  ]),
                  _: 2
                }, 1024)),
                _createVNode(_component_a_tab_pane, {
                  tab: 'Controles',
                  key: "2"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_engenharia_controle, {
                      controles: _ctx.computedControle,
                      "onUpdate:controles": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.computedControle) = $event)),
                      codigo: _ctx.props.codigoEngenharia,
                      empresas: _ctx.props.empresas,
                      codigoEngenharia: _ctx.props.codigoEngenharia,
                      visivel: true
                    }, null, 8, ["controles", "codigo", "empresas", "codigoEngenharia"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_tab_pane, {
                  tab: 'CIP',
                  key: "3"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_engenharia_cip, {
                      cips: _ctx.computedCips,
                      "onUpdate:cips": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.computedCips) = $event)),
                      empresas: _ctx.props.empresas,
                      codigoEngenharia: _ctx.props.codigoEngenharia,
                      codigoTipoProducao: _ctx.props.codigoTipoProducao,
                      editavel: _ctx.props.editavel
                    }, null, 8, ["cips", "empresas", "codigoEngenharia", "codigoTipoProducao", "editavel"])
                  ]),
                  _: 1
                })
              ]),
              _: 2
            }, 1024)
          ]),
          _: 2
        }, 1032, ["tab"]))
      }), 128))
    ]),
    _: 1
  }, 8, ["activeKey"]))
}